import * as _ from 'underscore';

declare var window: any;

let _modules: any = {};

export function registerModule(name, obj) {
    _modules[name] = obj;
}

export function getValidator(moduleName: string, str: string, args) {
    const path = str.split('.');
    var _module = _modules[moduleName];

    if (_module == null) {
        throw new Error(`Can\'t find validation module named '${moduleName}'`);
    }

    const validator = _.reduce<any, any>(
        path,
        (obj, field) => {
            if (obj != null) {
                obj = obj[field];
            }

            return obj;
        },
        _module
    );

    if (validator == null) {
        throw new Error(`Can\'t find validator ${str}  in module '${moduleName}'`);
    }

    if (typeof validator !== 'function') {
        throw new Error(`Validator ${str} in module '${moduleName}' was found, but it's not a function`);
    }

    if (args != null && args.length > 0) {
        return validator.apply(window, args);
    } else {
        return validator;
    }
}
